import * as React from 'react';
import { Input } from 'semantic-ui-react';

export interface SearchMessageProps {
  isLoading: boolean;
  onSearch(text: string | undefined): void;
}

export interface SearchMessageState {
  value: string | undefined;
}


export class SearchMessage extends
  React.Component<SearchMessageProps, SearchMessageState> {

  constructor(props: SearchMessageProps, state: SearchMessageState) {
    super(props, state);
    this.state = {
      value: '',
    };
  }

  handleOnChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    this.props.onSearch(event.currentTarget.value);
  }

  render() {
    return (
      <div>
        <Input 
          className="searchInput"
          fluid={true}
          size="large" 
          icon="search"
          iconPosition="left"
          loading={this.props.isLoading}
          placeholder="Search" 
          onChange={this.handleOnChange}
          id="searchField"
        />          
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SearchMessage/SearchMessage.tsx